<template>
  <div id="NavTop">
    <a
      class="history-report-link is-pulled-right"
      data-test="viewHistoryButton"
      @click="toggleHistoryVisibility"
    >
      <span
        class="has-text-white"
      >
        {{
          isReportHistoryVisible ?
            $t('seo_service.nav_top.hide_reports') :
            $t('seo_service.nav_top.show_reports')
        }}
      </span>
    </a>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'NavTop',
  data () {
    return {

    }
  },
  computed: {
    isReportHistoryVisible () {
      return this.$store.state.seoService.showHistory
    }
  },
  methods: {
    ...mapActions(['toggleHistoryVisibility'])
  }
}

</script>
<style scoped>
  a {
    z-index: 100;
  }
  .history-report-link {
    padding: 10px 20px 10px 20px;
  }
/*  .when-closed {
    display: none;
  }
  .nav-item:not(.collapsed) .when-opened {
    display: none;
  }*/
</style>
